<template>
    <button @click="show = true" class="btn btn-blue xs:btn-sm xs:text-xs sm:btn-sm sm:text-xs md:btn-sm md:text-xs lg:btn lg:text-sm">Give Feedback</button>

    <modal id="feedbackModal" v-if="show" @close="show = false">
        <template #header>Give Feedback</template>
        <template #body>
            <div class="py-2">
                <p class="paragraph">Your opinion is important to us. We would love to hear your thoughts, concerns or problems with anything so we can improve! Please give us your feedback by filling in the information bellow.</p>
                <div class="w-full mt-3">
                    <label for="message">Please leave your feedback below:</label>
                    <textarea @focus="formError=''" class="form-input-modal mt-2" id="message" v-model="message" type="text" rows="10" placeholder="Enter your feedback..."></textarea>
                </div>
                <div class="w-full p-0 mb-3 bg-red-500 px-2 py-1 text-white text-xs text-center" v-if="formError">
                    {{ formError }}
                </div>
            </div>
        </template>
        <template #footer>
            <div class="flex justify-center">
                <div class="btn btn-sm btn-yellow-ghost inline-flex mx-1" @click="show = false">Cancel</div>
                <div class="btn btn-sm btn-yellow inline-flex mx-1" @click="send">Send</div>
            </div>
        </template>
    </modal>

    <flash-message ref="flash"></flash-message>
</template>

<script setup>
import { ref } from 'vue';

const flash = ref(null);
const show = ref(false);
const message = ref('');
const formError = ref('');

const send = () => {
    if (message.value === '') {
        formError.value = 'Sorry, there was an error sending your feedback. Please provide your feedback.';
        return;
    }

    const route = window.route('main.feedback');

    const params = {
        message: message.value,
        user: window.currentUser,
        page: window.location.href,
        resolution: {
            height: window.innerHeight,
            width: window.innerWidth,
        },
    };

    axios.post(route, params)
        .then((response) => {
            message.value = '';
            flash.value.display('Feedback sent!');
        }).catch((error) => {
            flash.value.error('Error sending your feedback');
        }).then(() => {
            show.value = false;
        });
};
</script>

<style lang="scss">
#feedbackModal {
    @apply text-left;
    .modal-container {
        width: 34rem;
        @screen xs {
            width: 100%;
        }
    }
}
</style>
